// extracted by mini-css-extract-plugin
export default {"afterpayPlacement":"t0-z"};